function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg091CentralAfricanRepublic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 256,
    style: {
      fill: "#6DA544"
    },
    width: 211.478,
    height: 128
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.522,
    y: 256,
    style: {
      fill: "#6DA544"
    },
    width: 211.478,
    height: 128
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "0,0 0,0.006 0,128 211.478,128 211.478,0.006 300.522,0.006 300.522,128 512,128 512,0.006   512,0 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 300.522,
    y: 128,
    style: {
      fill: "#F0F0F0"
    },
    width: 211.478,
    height: 128
  }), /*#__PURE__*/React.createElement("rect", {
    y: 128,
    style: {
      fill: "#F0F0F0"
    },
    width: 211.478,
    height: 128
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "300.522,511.994 211.478,511.994 211.478,384 0,384 0,511.994 0,512 512,512 512,511.994    512,384 300.522,384  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "161.39,33.566 168.944,56.814 193.391,56.814 173.615,71.185 181.169,94.434 161.39,80.066    141.613,94.434 149.169,71.185 129.391,56.814 153.837,56.814  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg091CentralAfricanRepublic);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3Qgc3R5bGU9ImZpbGw6I0Q4MDAyNzsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIi8+CjxnPgoJPHJlY3QgeT0iMjU2IiBzdHlsZT0iZmlsbDojNkRBNTQ0OyIgd2lkdGg9IjIxMS40NzgiIGhlaWdodD0iMTI4Ii8+Cgk8cmVjdCB4PSIzMDAuNTIyIiB5PSIyNTYiIHN0eWxlPSJmaWxsOiM2REE1NDQ7IiB3aWR0aD0iMjExLjQ3OCIgaGVpZ2h0PSIxMjgiLz4KPC9nPgo8cG9seWdvbiBzdHlsZT0iZmlsbDojMDA1MkI0OyIgcG9pbnRzPSIwLDAgMCwwLjAwNiAwLDEyOCAyMTEuNDc4LDEyOCAyMTEuNDc4LDAuMDA2IDMwMC41MjIsMC4wMDYgMzAwLjUyMiwxMjggNTEyLDEyOCA1MTIsMC4wMDYgICA1MTIsMCAiLz4KPGc+Cgk8cmVjdCB4PSIzMDAuNTIyIiB5PSIxMjgiIHN0eWxlPSJmaWxsOiNGMEYwRjA7IiB3aWR0aD0iMjExLjQ3OCIgaGVpZ2h0PSIxMjgiLz4KCTxyZWN0IHk9IjEyOCIgc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHdpZHRoPSIyMTEuNDc4IiBoZWlnaHQ9IjEyOCIvPgo8L2c+CjxnPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6I0ZGREE0NDsiIHBvaW50cz0iMzAwLjUyMiw1MTEuOTk0IDIxMS40NzgsNTExLjk5NCAyMTEuNDc4LDM4NCAwLDM4NCAwLDUxMS45OTQgMCw1MTIgNTEyLDUxMiA1MTIsNTExLjk5NCAgICA1MTIsMzg0IDMwMC41MjIsMzg0ICAiLz4KCTxwb2x5Z29uIHN0eWxlPSJmaWxsOiNGRkRBNDQ7IiBwb2ludHM9IjE2MS4zOSwzMy41NjYgMTY4Ljk0NCw1Ni44MTQgMTkzLjM5MSw1Ni44MTQgMTczLjYxNSw3MS4xODUgMTgxLjE2OSw5NC40MzQgMTYxLjM5LDgwLjA2NiAgICAxNDEuNjEzLDk0LjQzNCAxNDkuMTY5LDcxLjE4NSAxMjkuMzkxLDU2LjgxNCAxNTMuODM3LDU2LjgxNCAgIi8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };